import ConfigList from 'Model/ConfigList'
import { branch } from 'Model/constants'

class DisabledTypes extends ConfigList
  @className = 'DisabledTypes'

  constructor: ->
    super('disabledTypes')

  @load: ->
    super('disabledTypes', @)

export default DisabledTypes
